import React from "react"
import * as layouts from "layouts"
import * as icons from "icons"
import * as routing from "brandguard/routing"
import { Link } from "react-router-dom"
import * as brands from "brands"

export default function Navigation(): JSX.Element {
	const brand = brands.caching.useCached()
	return (
		<layouts.containers.flex flexDirection="row" width="100%" textAlign="left" boxShadow="none" mb="15px">
			<layouts.containers.flex flexDirection="row" flex="1" borderBottom={layouts.theme.borders.grey.dark50alphamedium}>
				<Link to={routing.image.score(brand.id)} style={{ textDecoration: "none" }}>
					<layouts.containers.flex p="5px" flexDirection="row">
						<layouts.containers.flex>
							<icons.brandguard.image fillOpacity="0.5" pr="5px" />
						</layouts.containers.flex>
						<layouts.containers.span opacity="0.5" color={layouts.theme.colors.grey.dark50} fontSize="14px">
							Image
						</layouts.containers.span>
					</layouts.containers.flex>
				</Link>
				<layouts.containers.flex mx="20px" my="4px" borderRight={layouts.theme.borders.grey.dark50alphamedium} />
				<Link to={routing.document.score(brand.id)} style={{ textDecoration: "none" }}>
					<layouts.containers.flex p="5px" flexDirection="row">
						<layouts.containers.flex>
							<icons.brandguard.document fillOpacity="0.5" pr="5px" />
						</layouts.containers.flex>
						<layouts.containers.span opacity="0.5" color={layouts.theme.colors.grey.dark50} fontSize="14px">
							Document
						</layouts.containers.span>
					</layouts.containers.flex>
				</Link>
				<layouts.containers.flex mx="20px" my="4px" borderRight={layouts.theme.borders.grey.dark50alphamedium} />
				<layouts.containers.flex
					p="5px"
					flexDirection="row"
					borderBottom={`2px solid ${layouts.theme.colors.blue.blue}`}
				>
					<layouts.containers.flex>
						<icons.brandguard.text pr="5px" />
					</layouts.containers.flex>
					<layouts.containers.flex fontSize="14px" fontWeight="700" color={layouts.theme.colors.grey.dark50}>
						Text
					</layouts.containers.flex>
				</layouts.containers.flex>
				<layouts.containers.flex mx="20px" my="4px" borderRight={layouts.theme.borders.grey.dark50alphamedium} />
				<Link to={routing.video.score(brand.id)} style={{ textDecoration: "none" }}>
					<layouts.containers.flex p="5px" flexDirection="row">
						<layouts.containers.flex>
							<icons.brandguard.video strokeOpacity="0.5" pr="5px" />
						</layouts.containers.flex>
						<layouts.containers.span opacity="0.5" color={layouts.theme.colors.grey.dark50} fontSize="14px">
							Video
						</layouts.containers.span>
					</layouts.containers.flex>
				</Link>
			</layouts.containers.flex>
		</layouts.containers.flex>
	)
}
